// A HIBA-STÁTUSZ OLVASATA — „nincs jogod" vagy „most nem sikerült".
//
// ⚠️ EZ A FÁJL EGY ÉLES, ISMÉTLŐDŐ TÜNET MIATT LÉTEZIK: a felhasználó „nyomkodta a rendszert", és a lapok
// hirtelen azt írták ki, hogy **nincs jogosultsága** — holott volt. A felület 35 helyen így döntött:
//
//     const isForbidden = gated || status === 401 || status === 403;
//
// A 403 JOG-ÍTÉLET: a szerver megnézte, ki vagy, és nemet mondott. Ez ellen az újrapróbálás értelmetlen,
// ezért nincs is „Újra" gomb.
//
// A 401 NEM ÍTÉLET: azt jelenti, hogy a munkamenetedet ÉPPEN MOST nem tudjuk igazolni — lejárt az
// access-token (15 percenként normális), vagy a BFF nem érte el az Odin kulcs-készletét (deploy, hálózati
// zökkenő). A kliens ilyenkor csendben megújít és újrapróbál; ha a megújítás is átmeneti hibára fut, az
// EREDETI 401 ér ki a laphoz — és a lap eddig ebből „nincs jogosultságod"-ot csinált. A munkamenet közben
// ÉL, ezért bejelentkező oldal sem jelent meg: a felhasználónak úgy tűnt, a rendszer random kidobálja.
//
// A SZABÁLY TEHÁT: **jog-ítélet CSAK a 403** (és a kliens-oldali `gated`, ami a jogképből olvasott ítélet).
// Minden más hiba — 401 is — ÁTMENETI: a lap betöltési hibát mutat „Újra" gombbal, ami igaz és javítható
// állapot. Biztonsági lazítás nincs: a fal a BFF `@RequirePermissions` + az Odin RLS, ez a réteg csak azt
// dönti el, MELYIK ÜZENETET látja a felhasználó.

/**
 * Jog-ítélet-e a státusz? CSAK a **403**.
 *
 * @param status a válasz HTTP-státusza (`undefined`, ha nincs válasz — hálózati hiba)
 */
export function isForbiddenStatus(status: number | undefined): boolean {
  return status === 403;
}

/**
 * Jog-ítélet-e a hiba? A `gated` a KLIENS-oldali ítélet (a jogképből: „ehhez nincs jogod"), a státuszok
 * közül pedig bármelyik 403.
 *
 * MIÉRT VARARGS: a lapok egy része lapozott (`pages`), más része egyetlen választ kap — így mindkettő
 * ugyanazt a függvényt hívja, és nem keletkezik két változat a szabályból.
 */
export function isForbidden(gated: boolean, ...statuses: (number | undefined)[]): boolean {
  return gated || statuses.some(isForbiddenStatus);
}
